import { LitElement, html } from '@fil-global/webcomponents-base';
import componentStyles from './fil-card-footer.styles.js';

export class FilCardFooter extends LitElement {
  static styles = [componentStyles];

  render() {
    return html`<div class="fil-card__footer">
      <slot></slot>
    </div>`;
  }
}

export default FilCardFooter;
